var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_8_1",
    "data-name": "Component 8 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 20,
    height: 14,
    fill: "#00c22d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M18.305,1.2a.5.5,0,0,1,.495.5v10.61a.5.5,0,0,1-.495.495H1.694a.5.5,0,0,1-.494-.495V1.7a.5.5,0,0,1,.494-.5Zm0-1.2H1.694A1.7,1.7,0,0,0,0,1.7v10.61A1.7,1.7,0,0,0,1.694,14H18.305A1.7,1.7,0,0,0,20,12.305V1.7A1.7,1.7,0,0,0,18.305,0",
    fill: "#00c22d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M6.9,7V4.3A.769.769,0,0,1,8.05,3.638l2.334,1.348,2.335,1.348a.77.77,0,0,1,0,1.332L10.384,9.014,8.05,10.362A.769.769,0,0,1,6.9,9.7Z",
    fill: "#00c22d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconGreen);
export default __webpack_public_path__ + "static/media/playIconGreen.109d301a0e1091beee9b81202c353440.svg";
export { ForwardRef as ReactComponent };